import React from 'react';
import ServicePageTemplate from '@/components/ServicePageTemplate';

const AdBluePage: React.FC = () => {
  return <ServicePageTemplate serviceSlug="adblue" />;
};

export default AdBluePage;